import { Injectable } from '@angular/core';
import { ToastController, ToastOptions } from '@ionic/angular';

const DEFAULT_TOAST_OPTIONS: ToastOptions = {
  duration: 2000,
  position: 'top'
};

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private readonly _toastController: ToastController) {}

  success(message: string) {
    return this._openToast({
      ...DEFAULT_TOAST_OPTIONS,
      color: 'success',
      message
    });
  }

  warn(message: string) {
    return this._openToast({
      ...DEFAULT_TOAST_OPTIONS,
      color: 'warning',
      message
    });
  }

  error(message: string) {
    return this._openToast({
      ...DEFAULT_TOAST_OPTIONS,
      color: 'danger',
      message
    });
  }

  private async _openToast(options: ToastOptions) {
    const toast = await this._toastController.create(options);
    await toast.present();

    return toast.onDidDismiss();
  }
}
